// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/VectorBack.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/imageDefault.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productDrawer_drawer__2WLNw {
    z-index: 0;
    position: fixed;
    top: 0;
    right: 0;
    width: 85vw;
    height: 100vh;
    background: rgba(249, 249, 249, 1);
    z-index: 1000;
    padding: 50px 32px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.productDrawer_header__fLTlO {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.productDrawer_headerText__FuPt1 {
    font-weight: 700;
    font-size: 24px;
    margin-left: 12px;
}

.productDrawer_backButton__xBClc {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    width: 15px;
    height: 16.2px;
    border: none;
    font-size: 16px;
    cursor: pointer;
}

.productDrawer_tabs__4xaxy {
    width: 693px;
    display: flex;
    margin-bottom: 20px;
    position: relative;
    border-bottom: 2px solid #e0e0e0;
    gap: 16px;
}

.productDrawer_tabs__4xaxy button {
    position: relative;
    background: none;
    border: none;
    padding: 10px 16px;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
}

.productDrawer_tabs__4xaxy button.productDrawer_active__1m9dz {
    color: rgba(29, 135, 82, 1);
    font-weight: 500;
}

.productDrawer_tabs__4xaxy button.productDrawer_active__1m9dz::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: rgba(29, 135, 82, 1);
}


.productDrawer_content__IM-7z {
    background-color: rgba(255, 255, 255, 1);
    padding: 24px;
    border-radius: 12px;
}

.productDrawer_contentBlock__6Sc\\+p {
    display: flex;
}

.productDrawer_left__MXAGO {
    width: 30%;
    display: flex;
    margin-right: 24px;
    padding-right: 24px;
    border-right: 2px solid rgba(249, 249, 249, 1);
}

.productDrawer_photo__LCi96 {
    width: 160px;
    height: 160px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    margin-right: 24px;
    background-repeat: no-repeat;
    background-size: contain;
}

.productDrawer_contentInfoName__S\\+z7t {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
}
.productDrawer_contentHeadSubtitle__y0\\+xU,
.productDrawer_contentInfoNameSubtitle__l0qRj {
    text-align: left;
    font-size: 16px;
    color: rgba(33, 33, 33, 1);
    margin-top: 4px;
    margin-bottom: 16px;
}

.productDrawer_contentHeadSubtitle__y0\\+xU {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
}

.productDrawer_textPosition__Tn4qc {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
}

.productDrawer_textPosition__Tn4qc:last-child{
    margin-bottom: 0;
}

.productDrawer_rightHead__\\+fuSv {
    font-size: 18px;
    font-weight: bold;
}

.productDrawer_footerButtons__tgQN0 {
    text-align: left;
    margin-top: 30px;
    gap: 10px;
}

.productDrawer_footerButtons__tgQN0 button {
    flex: 1 1;
    margin-right: 12px;
    text-align: left;
    cursor: pointer;
    font-weight: bold;
}

.productDrawer_delete__vcU-9 { 
    background-color: #e74c3c ;
    color: white;
    border-radius: 4px;
    padding: 8.5px 12px; 
}
.productDrawer_edit__YrtmJ { 
    background: rgba(25, 29, 35, 1);
    color: white;
    padding: 8.5px 12px; 
    border-radius: 4px; 
}
.productDrawer_move__6RjbD { 
    border: 1px solid rgba(115, 115, 115, 1);
    color: rgba(115, 115, 115, 1);
    padding: 8.5px 12px; 
    border-radius: 4px; 
}
.productDrawer_print__3y1EM { 
    border: 1px solid rgba(115, 115, 115, 1);
    border-radius: 4px; 
    padding: 8.5px 12px; 
    color: rgba(115, 115, 115, 1);
}`, "",{"version":3,"sources":["webpack://./src/styles/productDrawer.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,eAAe;IACf,MAAM;IACN,QAAQ;IACR,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yDAA6C;IAC7C,4BAA4B;IAC5B,wBAAwB;IACxB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,sCAAsC;AAC1C;;;AAGA;IACI,wCAAwC;IACxC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yDAA+C;IAC/C,kBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;;IAEI,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,+BAA+B;IAC/B,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,wCAAwC;IACxC,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC","sourcesContent":[".drawer {\n    z-index: 0;\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 85vw;\n    height: 100vh;\n    background: rgba(249, 249, 249, 1);\n    z-index: 1000;\n    padding: 50px 32px;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n}\n\n.header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.headerText {\n    font-weight: 700;\n    font-size: 24px;\n    margin-left: 12px;\n}\n\n.backButton {\n    background-image: url(/public/VectorBack.png);\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 15px;\n    height: 16.2px;\n    border: none;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.tabs {\n    width: 693px;\n    display: flex;\n    margin-bottom: 20px;\n    position: relative;\n    border-bottom: 2px solid #e0e0e0;\n    gap: 16px;\n}\n\n.tabs button {\n    position: relative;\n    background: none;\n    border: none;\n    padding: 10px 16px;\n    font-size: 16px;\n    color: #333;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.tabs button.active {\n    color: rgba(29, 135, 82, 1);\n    font-weight: 500;\n}\n\n.tabs button.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: rgba(29, 135, 82, 1);\n}\n\n\n.content {\n    background-color: rgba(255, 255, 255, 1);\n    padding: 24px;\n    border-radius: 12px;\n}\n\n.contentBlock {\n    display: flex;\n}\n\n.left {\n    width: 30%;\n    display: flex;\n    margin-right: 24px;\n    padding-right: 24px;\n    border-right: 2px solid rgba(249, 249, 249, 1);\n}\n\n.photo {\n    width: 160px;\n    height: 160px;\n    background-image: url(/public/imageDefault.png);\n    margin-right: 24px;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n.contentInfoName {\n    text-align: left;\n    font-size: 24px;\n    font-weight: bold;\n}\n.contentHeadSubtitle,\n.contentInfoNameSubtitle {\n    text-align: left;\n    font-size: 16px;\n    color: rgba(33, 33, 33, 1);\n    margin-top: 4px;\n    margin-bottom: 16px;\n}\n\n.contentHeadSubtitle {\n    margin-top: 16px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.textPosition {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.textPosition:last-child{\n    margin-bottom: 0;\n}\n\n.rightHead {\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.footerButtons {\n    text-align: left;\n    margin-top: 30px;\n    gap: 10px;\n}\n\n.footerButtons button {\n    flex: 1;\n    margin-right: 12px;\n    text-align: left;\n    cursor: pointer;\n    font-weight: bold;\n}\n\n.delete { \n    background-color: #e74c3c ;\n    color: white;\n    border-radius: 4px;\n    padding: 8.5px 12px; \n}\n.edit { \n    background: rgba(25, 29, 35, 1);\n    color: white;\n    padding: 8.5px 12px; \n    border-radius: 4px; \n}\n.move { \n    border: 1px solid rgba(115, 115, 115, 1);\n    color: rgba(115, 115, 115, 1);\n    padding: 8.5px 12px; \n    border-radius: 4px; \n}\n.print { \n    border: 1px solid rgba(115, 115, 115, 1);\n    border-radius: 4px; \n    padding: 8.5px 12px; \n    color: rgba(115, 115, 115, 1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `productDrawer_drawer__2WLNw`,
	"header": `productDrawer_header__fLTlO`,
	"headerText": `productDrawer_headerText__FuPt1`,
	"backButton": `productDrawer_backButton__xBClc`,
	"tabs": `productDrawer_tabs__4xaxy`,
	"active": `productDrawer_active__1m9dz`,
	"content": `productDrawer_content__IM-7z`,
	"contentBlock": `productDrawer_contentBlock__6Sc+p`,
	"left": `productDrawer_left__MXAGO`,
	"photo": `productDrawer_photo__LCi96`,
	"contentInfoName": `productDrawer_contentInfoName__S+z7t`,
	"contentHeadSubtitle": `productDrawer_contentHeadSubtitle__y0+xU`,
	"contentInfoNameSubtitle": `productDrawer_contentInfoNameSubtitle__l0qRj`,
	"textPosition": `productDrawer_textPosition__Tn4qc`,
	"rightHead": `productDrawer_rightHead__+fuSv`,
	"footerButtons": `productDrawer_footerButtons__tgQN0`,
	"delete": `productDrawer_delete__vcU-9`,
	"edit": `productDrawer_edit__YrtmJ`,
	"move": `productDrawer_move__6RjbD`,
	"print": `productDrawer_print__3y1EM`
};
export default ___CSS_LOADER_EXPORT___;
